import {useState, useEffect, useSyncExternalStore} from 'react';

import { minWidthLg } from '../constants';

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < minWidthLg);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < minWidthLg);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
};

const subscribe = (callback: () => void) => {
  window.addEventListener('resize', callback);
  return () => window.removeEventListener('resize', callback);
};

export const getIsMobileSnapshot = () => window.innerWidth < minWidthLg;
const getServerSnapshot = () => false; // For SSR: assume not mobile by default

export function useIsMobileV2() {
  return useSyncExternalStore(subscribe, getIsMobileSnapshot, getServerSnapshot);
}
